import { compose, withProps } from 'recompose'
import { createWithLazyEntities } from '@infotech/lib-api-middleware'

import {
  TOIR_STATUSES_SCHEMA_NAME,
  toirStatusesSelector,
  toirStatusesApiActions,
  toirStatusesEntitiesSelector,
} from 'api/toirStatuses'

export const toirStatusesDataPropName = `toirStatuses`

const withToirStatuses = createWithLazyEntities({
  entitiesSelector: toirStatusesEntitiesSelector,
  dataSelector    : toirStatusesSelector,
  schemaName      : TOIR_STATUSES_SCHEMA_NAME,
  fetchApiAction  : toirStatusesApiActions.fetch,
  dataPropName    : toirStatusesDataPropName,
})


export const toirStatusesTransport = compose(
  withProps({
    query: {
      limit: -1,
    },
  }),
  withToirStatuses
)
